import { reactive } from 'vue';
// 注意这个数组保存着当前用户的所有权限code
// 但是这个数据是在用户登录之后才初始化的
// 也就是说没有登录的用户是没有任何权限的
let token = '';
let login: boolean | undefined;
let currentUserPermissionCode: string[] = [];

// const TOKEN_KEY = 'TOKEN_UG_FE_CONTEST_STUDENT';
const TOKEN_KEY = 'TOKEN_UG_FE_CONTEST';

export const AuthConf = reactive({
  key: TOKEN_KEY,
  login,
});

/**
 * 优先返回内存中的token
 * 其次返回localStorage中的token
 *
 * @export
 * @return {*}
 */
export function getToken() {
  if (token) {
    return token;
  }
  const localToken = localStorage.getItem(TOKEN_KEY) || '';
  if (localToken) {
    token = localToken;
    return token;
  }
}

/**
 * @export
 * @param {string} token
 */
export function setToken(newToken: string) {
  token = newToken;
  localStorage.setItem(TOKEN_KEY, newToken);
}

/**
 * 删除所有token
 *
 * @export
 */
export function removeToken() {
  token = '';
  localStorage.removeItem(TOKEN_KEY);
}

// 在用户登录时需要初始化该用户的权限列表
export function setAuth(codeList?: string[]) {
  currentUserPermissionCode = codeList || [];
}

// 在用户登出时需要重置数据
export function removeAuth() {
  currentUserPermissionCode = [];
}

/**
 * 标志当前用户已经登录
 *
 * @export
 */
export function setLogin() {
  login = true;
  AuthConf.login = login;
}

/**
 * 标志当前用户未登录
 *
 * @export
 */
export function removeLogin() {
  login = false;
  AuthConf.login = login;
}

// 判断当前用户是否已经登录
export function isLogin() {
  return login;
}

// 在正常ts代码中使用hasAuth方法
export function hasAuth(code: string | string[]) {
  const codeArr = typeof code === 'string' ? [code] : code;
  return codeArr.every(c => currentUserPermissionCode.indexOf(c) >= 0);
}

// 在模版中使用指令v-auth
export function createAuthPlugin() {
  return {
    install(app: any) {
      app.directive('auth', function (el: any, binding: any) {
        const permission = binding.value;
        if (!hasAuth(permission)) {
          if (binding?.modifiers?.disable) {
            // v-auth.disable="permission"
            // 可以给按钮置灰，而不是隐藏
            el.disabled = true;
          } else {
            el && el.parentNode && el.parentNode.removeChild(el);
          }
        }
      });
    },
  };
}

// 在下方定义使用到的所有权限码
// 禁止直接在代码中使用字符串作为权限码
export const USER_ADD = 'user:add';
export const USER_LOOK = 'user:look';
